import { type BuilderInfo } from "helpers/AppProvider.types";

/**
 * Which generation of the BTNet-Search service a surface talks to. Not
 * interchangeable: `v2` adds routes that `v1` lacks.
 */
export type SearchApiVersion = "v1" | "v2";

/**
 * Whether this builder is on the new search experience: the unified dialog
 * against `v2`, rather than the dropdown against `v1`. Distinct from
 * `AiPoweredSearch`, which decides AI search versus legacy `GlobalSearch`.
 *
 * Note: `GetBuilderFlags` returns `true` for a key missing from the payload,
 * so this reads as ON before the flag row exists.
 */
export function isSearchUxRedesignEnabled(builderInfo?: BuilderInfo | null): boolean {
    return builderInfo?.flags?.searchUxRedesign === true;
}

/** The service generation this builder's search surfaces should call. */
export function getSearchApiVersion(builderInfo?: BuilderInfo | null): SearchApiVersion {
    return isSearchUxRedesignEnabled(builderInfo) ? "v2" : "v1";
}
